/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { $ } from '../other/jquery-hooked.js';


function BoxCordWidget( container, id_A, id_B, ed_type, tend_to_right ) {
	this.container = container;
	this.id_A = id_A;
	this.id_B = id_B;
	this.ed_type = ed_type;
	this.tend_to_right = tend_to_right;
	this.elements = [];
}

BoxCordWidget.prototype.show = function() {
	if( this.elements.length===0 ) this.createElements();
	this.positionElements();
};

BoxCordWidget.prototype.hide = function() {
	if( this.elements.length!==0 ) this.destroyElements();
};

BoxCordWidget.prototype.toggle = function( show ) {
	if( show ) this.show();
	else this.hide();
};

BoxCordWidget.prototype.destroy = function() {
	this.hide();
	this.container = null;
	this.id_A = null;
	this.id_B = null;
};

BoxCordWidget.prototype.createElements = function() {
	this.elements[0] = $('<div class="box-cord-segment-1 md-sce-border-color-for-'+this.ed_type+'"><div class="box-cord-segment-1i md-sce-bg-color-for-'+this.ed_type+'"></div></div>');
	this.elements[1] = $('<div class="box-cord-segment-2 md-sce-border-color-for-'+this.ed_type+'"><div class="box-cord-segment-2i md-sce-bg-color-for-'+this.ed_type+'"></div></div>');
	this.elements[2] = $('<div class="box-cord-segment-3 md-sce-border-color-for-'+this.ed_type+'"><div class="box-cord-segment-3i md-sce-bg-color-for-'+this.ed_type+'"></div></div>');
	if( this.tend_to_right ) {
		// append in reversed order
		this.container.append(this.elements.slice().reverse());
	} else {
		// append in order
		this.container.append(this.elements);
	}
};

BoxCordWidget.prototype.destroyElements = function() {
	for( var i=0; i<3; ++i ) this.elements[i].remove();
	this.elements = [];
};

BoxCordWidget.prototype.positionElements = function() {
	var fixed_box_max_y_handle_offs = 5;
	var fixed_box_x_dist1 = 21;
	var i;

	if( this.elements.length ) {
		var offs_cnt_O = this.container.offset();
		var elem_A = $('#'+this.id_A),
			elem_B = $('#'+this.id_B);
		if( elem_A.length==0 || elem_B.length==0 ) {
			for( i=0; i<3; ++i ) this.elements[i].hide();
		} else {
			var offs_A = elem_A.offset(),
				offs_B = elem_B.offset(),
				y_handle_offs_A = Math.min( fixed_box_max_y_handle_offs, Math.round(elem_A.outerHeight()/2) ),
				y_handle_offs_B = Math.min( fixed_box_max_y_handle_offs, Math.round(elem_B.outerHeight()/2) );

			var x0 = offs_A.left + elem_A.outerWidth(),
				y0 = Math.max( offs_A.top + y_handle_offs_A, this.tend_to_right? 84:108 ),
				w0 = fixed_box_x_dist1;
			var y2 = Math.max( offs_B.top + y_handle_offs_B, this.tend_to_right?108:84 ),
				w2 = offs_B.left - x0 - w0 - 1;

			var x1 = x0 + w0,
				y1 = Math.max( Math.min(y0,y2), 64 ),
				h1 = Math.abs(y2-y0);

			if( this.tend_to_right ) {
				// -> render cords from middle to right panel
				// as is... but...
			} else {
				// -> render cords from middle to left panel
				// fix some coordinates...
				w2 = fixed_box_x_dist1;
				x1 = offs_B.left - w2;
				w0 = x1 - x0;
			}

			if( this.tend_to_right ) {
				if( x1 > offs_B.left ) {
					x1 = offs_B.left;
					w0 = Math.max(x1-x0,1);
				}
				if( x1+w2 < x0 ) {
					var op_B = elem_B.offsetParent(), op_B_offs = op_B.offset();
					if( x1+w2 < op_B_offs.left ) {
						if( w0<fixed_box_x_dist1) w0 = fixed_box_x_dist1;
						x1 = x0 + w0;
						w2 = op_B_offs.left - x1;
						w0 = x1 - x0;
					} else {
						w2 = Math.max(offs_B.left-x1,1);
					}
				}
			} else if( x1 < x0 ) {
				x1 = offs_B.left;
				var op_A = elem_A.offsetParent(), op_A_offs = op_A.offset();
				if( x0 > op_A_offs.left+op_A.outerWidth() ) x0 = op_A_offs.left+op_A.outerWidth();
				w0 = Math.max(x1-x0,1);
				w2 = Math.max(offs_B.left-x1,1);
			}

			// segment 0 -> horizontal from A to tmp1
			this.elements[0].css( {	left:	(x0-offs_cnt_O.left-1) + 'px',
				top:	(y0-offs_cnt_O.top)    + 'px',
				width:	(w0)+'px' } ).show();
			// segment 1 -> vertical from tmp1 to tmp2
			this.elements[1].css( {	left:	(x1-offs_cnt_O.left-1) + 'px',
				top:	(y1-offs_cnt_O.top)    + 'px',
				height:	(h1)+'px' } ).show();
			// segment 2 -> horizontal from tmp2 to B
			this.elements[2].css( {	left:	(x1-offs_cnt_O.left-1) + 'px',
				top:	(y2-offs_cnt_O.top)    + 'px',
				width:	(w2+1)+'px' } ).show();

			var y_min = Math.min(y0,y2),
				y_max = Math.max(y0,y2);
			var elem_op_A = elem_A.offsetParent(),
				elem_op_B = elem_B.offsetParent(),
				op_A_y2 = elem_op_A.offset().top + elem_op_A.outerHeight(),
				op_B_y2 = elem_op_B.offset().top + elem_op_B.outerHeight();
			if( y_min<offs_cnt_O.top+18 || y_max>/*offs_cnt_O.top+*/Math.max(op_A_y2,op_B_y2) ) {
				//hide...
				for( i=0; i<3; ++i ) this.elements[i].hide();
			}

		}
	}
};

export const MVBoxCords = function($) {
	return {
		create: function( container, id_A, id_B, ed_type, tend_to_right ) {
			return new BoxCordWidget(container,id_A,id_B,ed_type,tend_to_right);
		},
	};
}($); // namespace MVBoxCords
